import { withFormik } from 'formik'

import { PersonalInfo }         from '../../api'
import { InjectedStepperProps } from '../organisms'
import PersonalChunk            from './chunks/PersonalInformationChunk'
import {
  genValueMapper,
  proxyFormikSubmission,
}                               from './form-utils'
import {
  emptyPersonalInfo,
  personalSchema,
}                               from './schemas'
import asFormStep               from './wrappers/asFormStep'

const formikConfig = {
  mapPropsToValues: genValueMapper(emptyPersonalInfo),
  validationSchema: personalSchema,
  handleSubmit:     proxyFormikSubmission,
}

export default withFormik<InjectedStepperProps, PersonalInfo>(
  formikConfig,
)(
  asFormStep<PersonalInfo>(
    PersonalChunk,
  ),
)



// WEBPACK FOOTER //
// ./src/components/forms/PersonalInformationForm.tsx